import React, {ReactNode, useState} from "react";
import {Disclosure} from "@headlessui/react";
import {SubmitHandler} from "react-hook-form";
import {IconChevronUp} from "@tabler/icons-react";


interface DisclosureProps {
    accordionState?: boolean,
    accordionColor?: string,
    accordionTitle: string,
    icon?: ReactNode,
    children: ReactNode,
    submitButtonText?: string | ReactNode,
    btnDisabled?: boolean,
    formSubmit?: SubmitHandler<any>,
}

const DisclosureEx: React.FC<DisclosureProps> = ({accordionState = false, accordionColor, accordionTitle, icon, children, submitButtonText, btnDisabled = false, formSubmit}) => {
    let [openAcc, setOpenAcc] = useState<boolean>(accordionState);

    function openClose(state: boolean) {
        setOpenAcc(!state)
    }

    return (
        <Disclosure>
            <Disclosure.Button
                className={`${accordionColor ? accordionColor : 'bg-amber-400'} flex flex-row flex-wrap relative items-center h-auto w-full rounded-lg shadow-md
                            px-4 py-2 lg:px-6 mt-4 min-h-[40px] font-medium max-lg:text-xs`}
                onClick={() => {
                    openClose(openAcc)
                }}
            >
                <>{accordionTitle}&nbsp;&nbsp;{icon}</>
                <IconChevronUp className={`${openAcc ? 'rotate-180 transform' : ''} absolute right-2 h-5 w-5 text-white`}/>
            </Disclosure.Button>

            {openAcc && <Disclosure.Panel className="py-4 px-6 rounded-b-lg shadow" static>
                {() => <>
                    {submitButtonText && <form onSubmit={formSubmit}>
                        {children}
                        <div className="flex justify-end mt-5 border-t border-gray-200 pt-5">
                            <button type="submit" disabled={btnDisabled}
                                    className="ml-3 inline-flex justify-center rounded-md border border-transparent bg-blue-600 p-1.5 sm:p-2 md:py-2 md:px-4 text-sm font-medium text-white shadow-sm
                                                    hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50">
                                {submitButtonText}
                            </button>
                        </div>
                    </form>}
                    {!submitButtonText && <>
                        {children}
                    </>}</>}
            </Disclosure.Panel>}
        </Disclosure>
    )
}
export default DisclosureEx;